var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "url(#pattern0_178_3417)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_178_3417",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_178_3417",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_178_3417",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAChUlEQVR4nO3du27UQABGYTfhHUJ4DQoQEg0dtwJxKQEJKQjEwxEeAUJEIB1UlNBSJIDE9URWLLFynGBnvfbv7Pn68Y59drzJrqUpCkmSJEmSJGnigDPAU2AL+IrmVV7D18CT8tp2jXEW2Jl7CjrKO2C1y8owxuK9BVbaBClvUxrG4zZBys+MWc/LW1gxcdSM8PprwEZtGpttBu7VBq0VpwAjB6nmcK42jd1JTHwRUs6r8zxSJt63lPMySMUgYXCFZMEgWTBIFgySBYNkwSBZMEgWDJIFg2TBIFkwSBYMkgWDZMEgWTBIFgySBYMcuiCPgC/AJ+CyQQ6M8k4CngF/Zw67Y5CRglTPss7GKG0bZIQgwHpDjG/AJYMMHAR4CPypHe47cGXoGH2e1+Dz6GPiwIOGGD+Aq8VIWNYgwP0jYlwrRsQyBgHuAb8bYlwvRsayBQHuAL8aYtwoArBMQYDbDTF+AjeLECxLEOBuw21qSB+A871fiAXpPI8uA4BbDStjDJu9X4gF6TyPLgMMEhYk5Jb13lvW4Sh+qLdUfzf1P+DfOP/sTQpSjfUfw6Qg1Xi/OkkKUh3DLxeTglTH8ev3pCD/+YHqwjzHPYk+z2uyQY75CfflvMftyiDHP+SwVQwMV0jjZ8pn4CNw0SAHJvNO6lvKeXWeR8rE+5ZyXgapGCQMrpAsGCQLBsmCQbJgkCwYJAsGyYJBsmCQLBgkCwbJgkGyYJAsGCQLBsmCQbIw4SC7tTFu6DLyhi71LY82TkMURl4hVYwXJ9nyqHywTcNYb7ttXrnPnhbrTatt86ooq9U+e1qM7dYbS85EWSn32QNeNezcpu72qmu53nplSJIkSZIkSUWufVcZEoXT6Z7zAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.45d08c05738eccd2069f12b806a41571.svg";
export { ForwardRef as ReactComponent };